package pl.michal_cyran.brand_hub.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.browser.dom.observers.IntersectionObserver
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLElement

@Composable
fun VisibilityAware(
    modifier: Modifier = Modifier,
    content: @Composable (isVisible: Boolean) -> Unit
) {
    var isVisible by remember { mutableStateOf(false) }
    val elementRef = remember { mutableStateOf<HTMLElement?>(null) }

    LaunchedEffect(elementRef.value) {
        val observer = IntersectionObserver { entries, observer ->
            entries.forEach { entry ->
                if (entry.isIntersecting) {
                    isVisible = true
                    observer.unobserve(entry.target)
                }
            }
        }
        elementRef.value?.let { observer.observe(it) }
    }

    Div(
        attrs = modifier.toAttrs {
            ref {
                elementRef.value = it
                onDispose { }
            }
        }
    ) {
        content(isVisible)
    }
}